module.exports = __webpack_public_path__ + "images/1-small.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/paypal/1-small.png
 ** module id = 568
 ** module chunks = 0
 **/